import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button, ButtonProps } from './button';
import { cn } from '@/lib/utils';

interface EnhancedButtonProps extends ButtonProps {
  loading?: boolean;
  loadingText?: string;
  success?: boolean;
  successText?: string;
  icon?: React.ReactNode;
  rightIcon?: React.ReactNode;
}

export const EnhancedButton: React.FC<EnhancedButtonProps> = ({
  children,
  loading = false,
  loadingText,
  success = false,
  successText,
  icon,
  rightIcon,
  disabled,
  className,
  ...props
}) => {
  const isDisabled = disabled || loading;
  
  const getContent = () => {
    if (loading) {
      return (
        <>
          <Loader2 className="h-4 w-4 animate-spin" />
          {loadingText || children}
        </>
      );
    }
    
    if (success && successText) {
      return successText;
    }
    
    return (
      <>
        {icon}
        {children}
        {rightIcon}
      </>
    );
  };

  return (
    <Button
      {...props}
      disabled={isDisabled}
      className={cn(
        "transition-all duration-200 flex items-center gap-2",
        {
          "opacity-75": loading,
          "bg-green-600 hover:bg-green-700": success,
        },
        className
      )}
    >
      {getContent()}
    </Button>
  );
};